import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { BoobleModalService } from 'booble-modal';
import { AttachProofOperationComponent } from 'src/app/pages/admin/home/modals/attach-proof-operation/attach-proof-operation.component';
import { ConfirmExteriorPaymentComponent } from 'src/app/pages/admin/home/modals/confirm-exterior-payment/confirm-exterior-payment.component';
import { ExchangeInfoConfirmComponent } from 'src/app/pages/admin/home/modals/exchange-info-confirm/exchange-info-confirm.component';
import { ExchangeInfoComponent } from 'src/app/pages/admin/home/modals/exchange-info/exchange-info.component';
import { AdminOrderDetailModalComponent } from 'src/app/pages/admin/home/modals/order-details-modal/admin-order-detail-modal.component';
import { OrderReviewModalComponent } from 'src/app/pages/admin/home/modals/order-review-modal/order-review-modal.component';
import { PaymentConfirmComponent } from 'src/app/pages/admin/home/modals/payment-confirm/payment-confirm.component';
import { SettlementConfirmInboundComponent } from 'src/app/pages/admin/home/modals/settlement-confirm-inbound/settlement-confirm-inbound.component';
import { SettlementInfoConfirmComponent } from 'src/app/pages/admin/home/modals/settlement-info-confirm/settlement-info-confirm.component';
import { SettlementInfoComponent } from 'src/app/pages/admin/home/modals/settlement-info/settlement-info.component';
import { TreasuryInfoComponent } from 'src/app/pages/admin/home/modals/treasury-info/treasury-info.component';
import { SettlementDocumentsComponent } from 'src/app/pages/admin/orders-history/modals/settlement-documents/settlement-documents.component';

@Injectable({
  providedIn: 'root',
})
export class RouteModalService {
  constructor(
    private dialog: MatDialog,
    private readonly router: Router,
    private readonly notifierService: NotifierService,
    private readonly route: ActivatedRoute,
    private modalService: BoobleModalService
  ) {}

  openModalByRouteParam(param: string, orderId: string): void {
    switch (param) {
      case 'admin-order-detail':
        this.modalService.present(
          AdminOrderDetailModalComponent,
          Number(orderId)
        );
        break;
      case 'order-review-modal':
        this.modalService.present(OrderReviewModalComponent, Number(orderId));
        break;
      case 'treasury-info':
        this.modalService.present(TreasuryInfoComponent, Number(orderId));
        break;
      case 'exchange-info':
        this.modalService.present(ExchangeInfoComponent, Number(orderId));
        break;
      case 'exchange-info-confirm':
        this.modalService.present(
          ExchangeInfoConfirmComponent,
          Number(orderId)
        );
        break;
      case 'payment-confirm':
        this.modalService.present(PaymentConfirmComponent, Number(orderId));
        break;
      case 'settlement-info':
        this.modalService.present(SettlementInfoComponent, Number(orderId));
        break;
      case 'settlement-info-confirm':
        this.modalService.present(
          SettlementInfoConfirmComponent,
          Number(orderId)
        );
        break;
      case 'attach-proof-operation':
        this.modalService.present(
          AttachProofOperationComponent,
          Number(orderId)
        );
        break;
      case 'settlement-documents':
        this.modalService.present(
          SettlementDocumentsComponent,
          Number(orderId)
        );
        break;
      case 'confirm-exterior-payment':
        this.modalService.present(
          ConfirmExteriorPaymentComponent,
          Number(orderId)
        );
        break;

      default:
        this.notifierService.notify(
          'error',
          'Nenhum modal correspondente foi encontrado.'
        );
    }
  }

  clearRouteQueryParams() {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { modal: null, orderId: null },
      queryParamsHandling: 'merge',
      replaceUrl: true,
    });
  }

  verifyRouteParamsModal() {
    this.route.queryParams.subscribe((params) => {
      const modalParam = params['modal'];
      const orderId = params['orderId'];

      if (modalParam && orderId) {
        this.openModalByRouteParam(modalParam, orderId);
        this.clearRouteQueryParams();
      }
    });
  }
}
